module.exports = __webpack_public_path__ + "img/lr.b830f184.svg";